/* eslint-disable no-cond-assign */
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { LoyaltyModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import { BrandImageLoyalityModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import parseInt from "lodash/parseInt";
import { useSelector } from "react-redux";

import { constants } from "buffer";

export default function convertHtmlToObjectValues(
    str: string,
): { text: string; link: string; linkText: string; dataGaPromo: string, textAlign: string }[] {
    const resultArray: { text: string; link: string; linkText: string; dataGaPromo: string; textAlign: string }[] = [];
    // const liRegex = /<li data-ga-promo="(.*?)">\s*(?:([^<]*?)\s*)?<a href="(.*?)".*?>(.*?)<\/a>(?:\s*([^<]*?))?\s*<\/li>/g;
    // Improved Regex as per the Sonar cube issue:
     const liRegex = /<li data-ga-promo="([^"]*)">\s*([^<]*?)<a href="([^"]*)"[^>]*>([^<]*?)<\/a>([^<]*?)<\/li>/g;

    

    let match;
    while ((match = liRegex.exec(str)) !== null) {
        const textBefore = match[2]?.trim() || '';
        const textAfter = match[5]?.trim() || '';

        resultArray.push({
            dataGaPromo: match[1].trim(),
            link: match[3].trim(),
            linkText: match[4].trim(),
            text: [textBefore, textAfter].filter(Boolean).join(' ').trim(),
            textAlign: textBefore ? 'right' : (textAfter ? 'left' : '')
        });
    }
    return resultArray;
}
export const remainingSpendGoal = (goal: string, spend: string, symbol: any) => {
    const spend1 = parseFloat(spend);
    const spendValue = Math.floor(spend1);
    const newValue = parseInt(goal) - spendValue;
    const remainingGoal = Intl.NumberFormat("en-US").format(newValue);
    return remainingGoal === "NaN" || newValue < 0 ? `${symbol}0` : `${symbol}${remainingGoal}`;
};
export const fomratLoyaltyPoints = (value: string, symbol: any) => {
    const num = parseFloat(value);
    if (num < 0) {
        const newValue = Math.floor(num);
        const newValue1 = Intl.NumberFormat("en-US").format(newValue);

        return newValue1 === "NaN" ? 0 : `-${symbol}${newValue1}`;
    }
    const newValue = Intl.NumberFormat("en-US").format(num);
    return newValue === "NaN" ? `${symbol}0` : `${symbol}${newValue}`;

};

export const convertPercentage = (percentageValue: string) => {
    let num = parseInt(percentageValue);
    if (num > 100) {
        num = 100;
        return num;
    } if (num < 0) {
        num = 0;
        return num;
    }
    const data = Intl.NumberFormat("en-US").format(Math.floor(num));
    return data === "NaN" ? "" : `${data}`;

};
export const isCoveoPriceAvailable = (
    pricing: ProductPriceDto | null | undefined,
    qtyOrdered: number | null | undefined,
) => {
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    if (isPendingVerification) {
        return false;
    }
    if (pricing) {
        const { price: unitNetPrice } = getUnitNetPrice(pricing, qtyOrdered || 1);
        if (unitNetPrice > 0) {
            return true;
        }
    }
    return false;
};

export const getBrandNameForGAtag: any = (link: any) => {
    const brand_name = link.split("|");
    let brandName = brand_name[0];
    brandName = brandName?.toLocaleLowerCase().trim();
    brandName = brandName?.replace(/[&)#($:.',;*]/g, "");
    brandName = brandName?.replace(/  /g, "-");
    brandName = brandName?.replace(/ /g, "-");
    brandName = brandName?.replace("--", "-");
    return brandName;
};

export const checkoutmodalpopup = () => {
    const modalparentdiv = document.querySelectorAll("body > div:last-of-type");
    if (modalparentdiv.length >= 0) {
        modalparentdiv[0].classList.add("modalparent");
    }
};

export const displayBrandImages: any = (path: any) => {
    const imageUrl = path.split("|");
    const imagePath = `https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Brands/${imageUrl[1]}`;
    return imagePath;
};

export const brandImagesLink: any = (link: any) => {
    const imageLink = link.split("|");
    return imageLink[2];
};

export const formatUserId = (data: any) => {
    const Id = data?.split("-");
    return Id[0];
};

export const currentDate = () => {
    let userDateTime = new Date().toJSON().replace("T", " ");
    userDateTime = userDateTime == null || userDateTime === "" ? "" : userDateTime;
    return userDateTime;
};

export const formattedDateInGrid = (dateString: any) => {
    if (!dateString) {
        return "";
    }
    const newDate = new Date(dateString);
    const splitedDate = newDate.toString().split(" ");
    let finalDate = "";
    if (splitedDate) {
        finalDate = `${splitedDate[1]}. ${splitedDate[2]}, ${splitedDate[3]}`;
    }
    return finalDate;
};

export const formatUTCTime = (date: string) => {
    let userLastRefreshedTime = "";
    let fetchedDateTime = "";
    const hostname = window.location.hostname.toString();
    const isfr = hostname.indexOf("fr") > 0;
    const currentDateTime = new Date();
    const offsetMinutes = currentDateTime.getTimezoneOffset();
    const lastRefreshedTime = new Date(date);
    const localTime = new Date(lastRefreshedTime.getTime() - offsetMinutes * 60 * 1000);
    userLastRefreshedTime = localTime.toJSON().replace("T", " ");
    userLastRefreshedTime = userLastRefreshedTime == null || userLastRefreshedTime === "" ? "" : userLastRefreshedTime;
    const month = `0${localTime.getMonth() + 1}`.slice(-2);
    const year = localTime.getFullYear();
    const day = `0${localTime.getDate()}`.slice(-2);
    const hours = localTime.getHours();
    let hoursFormat = "";
    let ampm = "";
    if (localTime.getHours() > 12) {
        hoursFormat = `0${localTime.getHours() - 12}`.slice(-2);
        ampm = "p.m.";
    } else if (localTime.getHours() === 12) {
        hoursFormat = "12";
        ampm = "p.m.";
    } else if (localTime.getHours() === 0) {
        hoursFormat = "12";
        ampm = "a.m.";
    } else {
        hoursFormat = hoursFormat = `0${localTime.getHours()}`.slice(-2);
        ampm = "a.m.";
    }
    const minutes = `0${localTime.getMinutes()}`.slice(-2);
    if (isfr) {
        fetchedDateTime = ` ${day}-${month}-${year} à ${hoursFormat}:${minutes}`;
    } else {
        fetchedDateTime = ` ${month}/${day} at ${hoursFormat}:${minutes} ${ampm}`;
    }

    return fetchedDateTime;
};

export const checkVaildUserForHmiRewards = (loayltyState: LoyaltyModel) => {
    if (
        (loayltyState.currentPurchases == null || loayltyState.currentPurchases === "") &&
        (loayltyState.currentPending == null || loayltyState.currentPending === "") &&
        (loayltyState.currentGoal == null || loayltyState.currentGoal === "") &&
        (loayltyState.currentPercentToGoal == null || loayltyState.currentPercentToGoal === "") &&
        (loayltyState.currentPrivate == null || loayltyState.currentPrivate === "") &&
        (loayltyState.currentFeatured == null || loayltyState.currentFeatured === "") &&
        (loayltyState.earned == null || loayltyState.earned === "") &&
        (loayltyState.redeemed == null || loayltyState.redeemed === "") &&
        (loayltyState.balance == null || loayltyState.balance === "") &&
        (loayltyState.bonusCategorySpend == null || loayltyState.bonusCategorySpend === "")
    ) {
        return false;
    }
    return true;

};
export const hmiSettingsBrandImages = () => {
    const brandImages: any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );
    const brandFormattedImages: BrandImageLoyalityModel[] = [];
    const hmiImages = Object.keys(brandImages).filter(item => item.includes("exclusiveBrandTile"));
    hmiImages.forEach(item => {
        if (checkifImageisEmpty(brandImages[item])) {
            brandFormattedImages.push({
                id: getRandomInt(0, 9),
                imageUrl: displayBrandImages(brandImages[item]),
                imageLink: brandImagesLink(brandImages[item]),
                brandName: getBrandNameForGAtag(brandImages[item]),
            });
        }
    });
    return brandFormattedImages;
};

export const getRandomInt = (min: number, max: number) => {
    const range = max - min + 1;
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    const randomValue = randomBuffer[0] / (0xffffffff + 1);
    return Math.floor(randomValue * range) + min;
};

export const checkifImageisEmpty = (path: string) => {
    if (path !== "") {
        return true;
    }
    return false;

};

// This function is being used in P21 ----- P21 Change
export const getKeyValuePairsFromHtmlString = (htmlString: string, lookUpKey: string, lookUpValue: string) => {
    if (IS_SERVER_SIDE) return false;

    const decodedHtmlString: any = new DOMParser().parseFromString(htmlString, "text/html").documentElement.textContent;
    const parser = new DOMParser();
    const doc = parser.parseFromString(decodedHtmlString, "text/html");
    const rows = doc.querySelectorAll("table.spec-table tr");
    let keyValuePairs: any = [];

    rows.forEach((row: { querySelectorAll: (arg0: string) => any }) => {
        const cells = row.querySelectorAll("td");
        for (let i = 0; i < cells.length; i += 2) {
            const key = cells[i]?.textContent?.trim();
            const value = cells[i + 1]?.textContent?.trim();
            if (key && value) {
                keyValuePairs.push({ key, value });
            }
        }
    });

    let flag = false;
    keyValuePairs.forEach((pair: { key: any; value: any }) => {
        if (
            pair.key.toLowerCase() === lookUpKey.toLowerCase() &&
            pair.value.toLowerCase().trim() === lookUpValue.toLowerCase().trim()
        ) {
            flag = true;
        }
    });

    return flag;
};

export const hmiSettingsFeaturedSupplier1 = () => {
    const brandImages: any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );

    const supplierFormattedImages1: BrandImageLoyalityModel[] = [];
    const hmiImages = Object.keys(brandImages).filter(item => item.includes("suppliers1Tile"));
    hmiImages.forEach(item => {
        if (checkifImageisEmpty(brandImages[item])) {
            supplierFormattedImages1.push({
                id: getRandomInt(0, 9),
                imageUrl: displayBrandImages(brandImages[item]),
                imageLink: brandImagesLink(brandImages[item]),
                brandName: getBrandNameForGAtag(brandImages[item]),
            });
        }
    });
    return supplierFormattedImages1;
};
export const hmiSettingsFeaturedSupplier2 = () => {
    const brandImages: any = useSelector(
        (state: CustomApplicationState) => state.context.settings.settingsCollection.hmiRewardsSettingSettings,
    );
    const supplierFormattedImages2: BrandImageLoyalityModel[] = [];
    const hmiImages = Object.keys(brandImages).filter(item => item.includes("suppliers2Tile"));
    hmiImages.forEach(item => {
        if (checkifImageisEmpty(brandImages[item])) {
            supplierFormattedImages2.push({
                id: getRandomInt(0, 9),
                imageUrl: displayBrandImages(brandImages[item]),
                imageLink: brandImagesLink(brandImages[item]),
                brandName: getBrandNameForGAtag(brandImages[item]),
            });
        }
    });
    return supplierFormattedImages2;
};

export let cartModifiedFlag = false;

export const addCartModifiedToLocalStorage = () => {
    cartModifiedFlag = true;
};

export const removeCartModifiedFromLocalStorage = () => {
    cartModifiedFlag = false;
};

export const getIfCartIsModifiied = (): boolean => {
    cartModifiedFlag = false;
    return cartModifiedFlag;
};
export const isPriceAvailable = (
    pricing: ProductPriceDto | null | undefined,
    qtyOrdered: number | null | undefined,
) => {
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );

    if (isPendingVerification) {
        return false;
    }
    if (pricing) {
        const { price: unitNetPrice } = getUnitNetPrice(pricing, qtyOrdered || 1);
        if (unitNetPrice > 0) {
            return true;
        }
    }
    return false;
};

export const formatPrice = (num: string) => {
    // Trim whitespace from input
    const trimmedNum = num.trim();

    // Check if the trimmed string is a valid number
    if (!/^-?\d+(\.\d+)?$/.test(trimmedNum)) {
        return num; // Return original if it's not a valid number
    }

    const number = parseFloat(trimmedNum);

    return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2, // This will make sure to have the decimals as 00 if not actual value present.
        maximumFractionDigits: 2,
    }).format(number);
};

export const priorStartDate = (num: number) => {
    const todaydate = new Date();
    const priorDate = new Date(new Date().setDate(todaydate.getDate() - num));
    return priorDate;
};

export const setRememberedUserName = (userName: any) => localStorage.setItem("rememberedUserName", userName);

export const getRememberedUserName = () => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const userName = localStorage.getItem("rememberedUserName");
        return userName;
    }
    return null;
};

export const spaceValidation = (inputValue: any) => {
    const normalizedValue = inputValue.replace(/^[ ]+/g, "").replace(/\s\s+/g, " ");
    return normalizedValue;
};

export const getPaginationMessage = (
    page: number,
    pageSize: number,
    totalItemCount: number,
    selectedfromdropdown: boolean = false,
) => {
    let startIndex = (page - 1) * pageSize + 1;

    if (selectedfromdropdown === true) {
        startIndex = 1;
    }

    const endIndex = Math.min(startIndex + pageSize - 1, totalItemCount);

    const showingMessage = `${startIndex}-${endIndex} of ${totalItemCount}`;
    return showingMessage;
};

export const getDisplayRange = (pagination: any, orderDefaultParam: any): { start: number; end: number } => {
    const { currentPage, pageSize, totalItemCount } = pagination;
    const start = (currentPage - 1) * pageSize + 1;
    let end = Math.min(currentPage * pageSize, totalItemCount);
    if (pageSize !== orderDefaultParam.pageSize) {
        const newPageSize = orderDefaultParam.pageSize;
        const newCurrentPage = Math.ceil(start / newPageSize);
        end = Math.min(newCurrentPage * newPageSize, totalItemCount);
    }
    return { start, end };
};

export const findNextMultiple = (minValue: number, currentValue: number) => {
    const nextMultiple = Math.ceil(currentValue / minValue) * minValue;
    return nextMultiple;
};
export const isMultipleOfValue = (number: number, multipleOf: number) => {
    return number % multipleOf === 0;
};

export const setOrderType = (order: string | undefined) => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const cartType = localStorage.setItem("cartType", order as string);
        return cartType;
    }
    return null;
};

export const getOrderType = () => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const cartType = localStorage.getItem("cartType");
        return cartType;
    }
    return null;
};

export const setPLPUrl = (url: string | undefined) => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const plpurl = sessionStorage.setItem("plpUrl", url as string);
        return plpurl;
    }
    return null;
};

export const getPLPUrl = () => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const url = sessionStorage.getItem("plpUrl");
        return url;
    }
    return null;
};

export const getCurrentUrl = () => {
    if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
        const url = window.location.href;
        return url;
    }
    return null;
};

export const getSessionStorage = () => {
    if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        return sessionStorage;
    }
    return null;
};

interface MenuItem {
    showMyAccount: boolean;
    showInvoices: boolean;
    showOrder: boolean;
    showReorder: boolean;
    showQuote: boolean;
    showRequestaQuote: boolean;
    showQuickOrder: boolean;
    showViewStatements: boolean;
    showMyLists: boolean;
    showReturns: boolean;
}

export const getMenuItems = (showMyAccMenuItems: MenuItem) => {
    const roles: Array<string> = [];
    if (showMyAccMenuItems.showMyAccount) {
        roles.push("Account");
    }
    if (showMyAccMenuItems.showInvoices) {
        roles.push("Invoices");
    }
    if (showMyAccMenuItems.showOrder) {
        roles.push("My Orders");
    }
    if (showMyAccMenuItems.showReorder) {
        // we used Reorder Access for Recently Purchased Products
        roles.push("Recently Purchased Products");
    }
    if (showMyAccMenuItems.showQuote) {
        roles.push("My Quotes");
    }
    // My Account slide out story changes to remove
    // if (showMyAccMenuItems.showRequestaQuote) {
    //     roles.push("Request Quote Form");
    // }
    if (showMyAccMenuItems.showQuickOrder) {
        roles.push("Quick Order");
    }
    if (showMyAccMenuItems.showMyLists) {
        roles.push("My Lists");
    }
    // commented to fix defect ADINA 61442
    // if (showMyAccMenuItems.showRequestaQuote) {
    //     roles.push("Request Quote Form");
    // }

    if (showMyAccMenuItems.showViewStatements) {
        roles.push("View My Statements");
    }
    if (showMyAccMenuItems.showReturns) {
        roles.push("Returns");
    }
    return roles;
};

export const removeZeroPrefix = (value: string) => {
    if (value && value.startsWith("0")) {
        value = value.slice(1);
    }
    return value;
};

export const checkExpirationDate = (month: any, year: any) => {
    const d = new Date();
    month = parseInt(month);
    year = year.length === 2 ? parseInt(d.getFullYear().toString().substring(0, 2) + year) : year;
    if (year === d.getFullYear() && month < d.getMonth() + 1) {
        return true;
    }

    if (year < d.getFullYear()) {
        return true;
    }

    return false;
};

export const compareAddress = (obj1: any, obj2: any) => {
    if (
        obj1 &&
        obj2 &&
        obj1.address1.trim().toLowerCase() === obj2.newSTAddress1.trim().toLowerCase() &&
        obj1.address2.trim().toLowerCase() === obj2.newSTAddress2.trim().toLowerCase() &&
        obj1.city.trim().toLowerCase() === obj2.newSTCity.trim().toLowerCase() &&
        obj1.companyName.trim().toLowerCase() === obj2.newSTCompnayName.trim().toLowerCase() &&
        obj1.state.abbreviation.trim().toLowerCase() === obj2.newSTState.trim().toLowerCase() &&
        obj1.postalCode.trim() === obj2.newSTPostal.trim()
    ) {
        return true;
    }
    return false;

};

export const preventBackNavigation = () => {
    window.history.forward(); // move forward first to avoid going back after clearing history
    setTimeout(function () {
        window.history.forward(); // move forward again to ensure the history is cleared
    }, 0);
    //
    window.history.pushState(null, "", "/");
};

export const formatPayload = (url: any) => {
    const formatPayload = url && url.split("?")[1].split("&")[1];
    const personaType = url && url.split("?")[1].split("&")[4].split("=")[1];
    const customerDC = url && url.split("?")[1].split("&")[4].split("=")[3];
    const customerNumber = url && url.split("?")[1].split("&")[4].split("=")[2];
    const startDate = decodeURIComponent(formatPayload).split(" ");
    const formateDate = startDate[0].split("=")[1];
    const formatTime = startDate[1];

    const previewbannerPayload = [...[personaType, customerDC, customerNumber, formateDate, formatTime]];
    return previewbannerPayload;
};

export const checkmultipleQty = (qtyOrdered: number, minqty: number) => {
    if ((qtyOrdered / minqty) % 1) {
        return true;
    }
    return false;
};

export const checkAllowedQuantity = (qtyOrdered: number, minqty: number) => {
    if (minqty) {
        const ismultipleQty = checkmultipleQty(qtyOrdered, +minqty);
        if (qtyOrdered < +minqty || ismultipleQty) {
            return false;
        }
    }
    return true;
};

export function containsPortNumber(str: string) {
    if (str) {
        const portRegex =
            /\b(0|[1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])\b/;
        return portRegex.test(str);
    }
    return false;

}
export const TrimPrice = (num: string) => parseFloat(num).toFixed(2);

// The below function is being used by P21 ----- P21 Change
export const formatDate = (inputDate: any): string => {
    const date = new Date(inputDate);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const formattedDate = months[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear();
    return formattedDate;
};

// The below function is being used by P21 ----- P21 Chang
export const addZeroPrefix = (value: string) => {
    if (value && value.length == 1) {
        value = "0" + value;
    }
    return value;
};

// The below commented code is being used in Spire Prod.
// export function formatDate(dateStr: string) {
//    const date = new Date(dateStr);
//    const options: any = { month: "short", day: "2-digit", year: "numeric" };
//    return date.toLocaleDateString("en-US", options).replace(",", ".");
// }
export function formatDateTime(date: Date) {
    const date1 = new Date(date.toString());
    const options: any = { month: "short", day: "2-digit", year: "numeric" };
    return date1.toLocaleTimeString("en-US", options).replace(",", ".");
}

export function formatEndDateTime(date: Date) {
    const date1 = new Date(date.toString());
    const minute = date1.getMinutes();
    const hour = date1.getHours();

    if (hour == 0) {
        date1.setMinutes(59);
        date1.setHours(23);
    }

    const options: any = { month: "short", day: "2-digit", year: "numeric" };
    return date1.toLocaleTimeString("en-US", options).replace(",", ".");
}

export function replaceZeroPriceWithFree(inputStr: string) {
    // Check for the exact price of "$0.00" and replace it with "Free"
    const zeroPriceRegex = /\$0\.00/;
    if (zeroPriceRegex.test(inputStr)) {
        return inputStr.replace(zeroPriceRegex, "FREE");
    }
    return inputStr; // Return the original string if $0.00 is not found
}

export const getMaxProductHeight = (selector: string): number => {
    const itemProductHeight = document.querySelectorAll(selector);
    let maxProductHeight = 10;

    if (window.innerWidth > 767) {
        itemProductHeight.forEach(item => {
            maxProductHeight = Math.max(maxProductHeight, item.clientHeight);
        });
    }

    return maxProductHeight;
};

export const saleEndDate = (pricing: any) => {
    let basicSaleEndDate = "";
    const _MS_PER_DAY: number = 1000 * 60 * 60 * 24;
    if (pricing && pricing?.additionalResults && pricing?.additionalResults?.saleEndDate) {
        basicSaleEndDate = pricing.additionalResults.saleEndDate;

        var utcTime = new Date().getUTCHours();
        var today = new Date().setHours(utcTime - 5);
        var saleUtcHours = new Date(basicSaleEndDate).getUTCHours();
        var seDate = new Date(basicSaleEndDate).setHours(saleUtcHours - 5);

        var td = new Date(today);
        var sd = new Date(seDate);
        const utc1 = Date.UTC(td.getFullYear(), td.getMonth(), td.getDate());
        const utc2 = Date.UTC(sd.getFullYear(), sd.getMonth(), sd.getDate());
        var diff: number = Math.floor((utc2 - utc1) / _MS_PER_DAY);
        if (sd <= td) {
            return "";
        }
        const splitedDate = basicSaleEndDate.split("/");
        if (splitedDate.length > 1) {
            basicSaleEndDate = `${splitedDate[0]}/${splitedDate[1]}`;
        }
    }
    return basicSaleEndDate;
};

export const showMonthlyFlyer = (className: any) => {
    const childLinks = document.querySelectorAll(`.${className} span`);

    childLinks.forEach((link: any) => {
        const spanValue = link.textContent?.trim(); // Use .trim() to remove extra whitespace
        if (spanValue === "Monthly Flyer" || spanValue === "Monthly Sales Flyer") {
            const parentDiv = link.closest("div");
            const parentButton = link.closest("button");

            if (parentButton) {
                parentButton.remove();
            } else if (parentDiv) {
                parentDiv.remove();
            } else {
                link.remove();
            }
        }
        return true;
    });
};

export const formatCurrencyWithComma = (value: any) => {
    if (typeof value === "number") {
        value = value.toString();
    }

    let numericValue = value.replace(/[^\d.-]/g, "");

    let numberValue = parseFloat(numericValue);
    if (isNaN(numberValue)) {
        return "$0.00";
    }

    let formattedValue = numberValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return `$${formattedValue}`;
};

// export const isExpireQuoteWarning = (date: string) => {
//     let expireQuoteDays = undefined;
//     const dateParts = date.split(" ");
//     const month = dateParts[0];
//     const day = dateParts[1].replace(",", "");
//     const year = dateParts[2];
//     let out = month + "/" + day + "/" + year;
//     let expireQuote = new Date(out);
//     let currentDate = new Date();
//     let days = Math.floor((expireQuote.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
//     if (days < 3 && days >= -1) {
//         expireQuoteDays = days + 1;
//         return true;
//     }
//     return false;
// };
export const isExpireQuoteWarning = (date: string) => {
    let expireQuoteDays = undefined;
    const sanitizedDateStr = date?.replace(".", " ");
    const expireQuote = new Date(sanitizedDateStr);
    const currentDate = new Date();

    expireQuote.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const msPerDay = 1000 * 60 * 60 * 24;
    const days = Math.floor((expireQuote.getTime() - currentDate.getTime()) / msPerDay); // ⬅️ note the change

    if (days < 4 && days >= -1) {
        expireQuoteDays = days;
        return true;
    }

    return false;
};

// export const isQuoteExpired = (date: string) => {
//     const dateParts = date.split(" ");
//     const month = dateParts[0];
//     const day = dateParts[1].replace(",", "");
//     const year = dateParts[2];
//     let out = month + "/" + day + "/" + year;
//     let expireQuote = new Date(out);
//     let currentDate = new Date();
//     let days = Math.floor((expireQuote.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
//     if (days < -1) {
//         return true;
//     }
//     return false;
// };

export const isQuoteExpired = (date: string) => {
    const expiry = new Date(date);
    const currentDate = new Date();
    expiry.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (expiry < currentDate) return true;
    else return false;
};
export const getMarkerIcon = (index: any, isHovered: boolean, marker: any): string => {
    let url: any;
    let backResultFlag: any;
    if (typeof window !== "undefined") {
        url = window.location.href.includes("DealerDetails");
    }

    const storedValue = localStorage.getItem("storedValue");
    const searchresultvalue = localStorage.getItem("searchresults");

    const backgroundColor =
        url && searchresultvalue === "true"
            ? isHovered
                ? "#fff"
                : "#2d5787"
            : storedValue && url
                ? "#fff"
                : isHovered
                    ? "#fff"
                    : "#2d5787";

    const textColor =
        url && searchresultvalue === "true"
            ? isHovered
                ? "#2d5787"
                : "#fff"
            : storedValue && url
                ? "#2d5787"
                : isHovered
                    ? "#2d5787"
                    : "#fff";

    const borderColor = "#2d5787";

    let displayValue;
    if (location.pathname.includes("/dealerlocator") && backResultFlag === "false") {
        displayValue = index;
    } else if (location.pathname.includes("/DealerDetails")) {
        if (searchresultvalue === "true") {
            displayValue = index;
        } else {
            displayValue = storedValue;
        }
    } else {
        displayValue = index;
    }

    return `data:image/svg+xml;base64,${btoa(`
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="60">
            <!-- Rectangle with background color -->
            <rect width="31" height="35" x="4.5" y="1" style="fill:${backgroundColor}; stroke:${borderColor}; stroke-width:1;" />
     
            <!-- Display either stored value or index -->
            <text x="20" y="23" font-size="15" fill="${textColor}" text-anchor="middle" font-family="Arial">${displayValue}</text>
     
            <!-- Downward-pointing triangle (aligned with the center of the rectangle's bottom edge) -->
            <path d="M15.5 36 L24.5 36 L20 42 Z" fill="${backgroundColor}" /> <!-- Arrow pointing down with tip at bottom -->
     
            <!-- Left border for the triangle -->
            <path d="M15.5 36 L20 42" style="fill:none; stroke:${borderColor}; stroke-width:1;" /> <!-- Left border -->
           
            <!-- Right border for the triangle -->
            <path d="M24.5 36 L20 42" style="fill:none; stroke:${borderColor}; stroke-width:1;" /> <!-- Right border -->
        </svg>
    `)}`;
};

interface ImageModel {
    id: string;
    imageAltText: string;
    imageType: string;
    largeImagePath: string;
    mediumImagePath: string;
    smallImagePath: string;
    name: string;
    sortOrder: number;
}

interface Product {
    id: string;
    productTitle: string;
    images: ImageModel[];
    properties: {
        video1Url?: string;
        video2Url?: string;
        thumbnail1Url?: string;
        thumbnail2Url?: string;
    };
}

export const getUpdatedImages = (product: any): ImageModel[] => {
    const {
        video1Url: mvpvideoLink1,
        video2Url: mvpvideoLink2,
        thumbnail1Url: thumbnailBg1,
        thumbnail2Url: thumbnailBg2,
    } = product.properties;
    const imagesData = product.images || [];

    const videoLinks: ImageModel[] = [];

    if (mvpvideoLink1) {
        videoLinks.push({
            id: `${product.id}-1`,
            imageAltText: product.productTitle || "",
            imageType: "video",
            largeImagePath: mvpvideoLink1,
            mediumImagePath: mvpvideoLink1,
            name: product.productTitle || "",
            smallImagePath: thumbnailBg1 || "",
            sortOrder: 1,
        });
    }

    if (mvpvideoLink2) {
        videoLinks.push({
            id: `${product.id}-2`,
            imageAltText: product.productTitle || "",
            imageType: "video",
            largeImagePath: mvpvideoLink2,
            mediumImagePath: mvpvideoLink2,
            name: product.productTitle || "",
            smallImagePath: thumbnailBg2 || "",
            sortOrder: 2,
        });
    }

    const updatedImages = [
        ...imagesData.map((image: any) => ({
            id: image.id,
            imageAltText: image.imageAltText || "",
            imageType: image.imageType || "Static",
            largeImagePath: image.largeImagePath,
            mediumImagePath: image.mediumImagePath,
            smallImagePath: image.smallImagePath,
            name: image.name || "Image",
            sortOrder: image.sortOrder || 0,
        })),
        ...videoLinks,
    ];

    return updatedImages;
};

export const convertCardTypeToName = (cardType: string) => {
    let cardName = "";
    if (cardType === "AX") {
        cardName = "Amex";
    } else if (cardType === "VS") {
        cardName = "Visa";
    } else if (cardType === "MC") {
        cardName = "Master Card";
    } else if (cardType === "DC") {
        cardName = "Discover";
    } else {
        cardName = "Unknown";
    }
    return cardName;
};

interface PromoItem {
    link: string;
    linkText: string;
    secondLinkText: string;
    imgAlt: string;
    imgSrc: string;
    description: string;
    ctaText: string;
}

export function convertPromoHtmlToObjectValues(html: string): PromoItem[] {
    const promoItems: PromoItem[] = [];
    const parser = new DOMParser();
    const document = parser.parseFromString(html, 'text/html');
    const promoDivs = document.body.querySelectorAll('div');

    promoDivs.forEach((promoDiv) => {
        const anchorElements = Array.from(promoDiv.querySelectorAll('a'));
        const imageElements = promoDiv.querySelectorAll('img');
        const descriptionParagraph = promoDiv.querySelector('p');

        if (anchorElements.length > 0 && imageElements.length > 0 && descriptionParagraph) {
            const primaryAnchor = anchorElements[0];
            const secondaryAnchor = anchorElements[1];
            const callToActionAnchor = anchorElements[anchorElements.length - 1];
            const primaryImage = imageElements[0];

            promoItems.push({
                link: primaryAnchor.getAttribute('href') || '',
                linkText: primaryAnchor.textContent?.trim() || '',
                secondLinkText: secondaryAnchor?.textContent?.trim() || '',
                imgAlt: primaryImage.getAttribute('alt') || '',
                imgSrc: primaryImage.getAttribute('src') || '',
                description: descriptionParagraph.textContent?.trim() || '',
                ctaText: callToActionAnchor.textContent?.trim() || '',
            });
        }
    });
    return promoItems;
}

export const handleZoneLinkClick = (
    event: React.MouseEvent,
    onHandleClose: Function,
    zoneRef: React.RefObject<HTMLDivElement>
) => {
    const { target } = event;
    const href = (target as HTMLElement).closest('a')?.getAttribute('href');
    if (href && zoneRef.current?.contains(target as Node)) {
        onHandleClose();
    }
};

// returns a string in phone number format ex: (123) 456-7890
export const formatPhoneNumber = (number: string) => {
    var numericOnly = number.replace(/\D/g, "");
    var formattedNumber =
        "(" + numericOnly.substring(0, 3) + ") " + numericOnly.substring(3, 6) + "-" + numericOnly.substring(6, 10);

    return formattedNumber;
};
export function useIsPRDomain(): boolean {
    if (typeof window !== "undefined" && window.location.hostname.endsWith(".pr")) {
        return true;
    }
    return false;
}
export function isUSDomain(): boolean {
    if (typeof window !== "undefined" && window.location.hostname.endsWith(".us")) {
        return true;
    }
    return false;
}